import { takeLatest, call, put } from 'redux-saga/effects'
import certificatesList from 'api/administration/certificates/List'
import destroyCertificate from 'api/administration/certificates/Destroy'

import * as fromActions from 'store/actions/certificates.action'


import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'


async function getList() {
  return await certificatesList()
}

async function handleDestroy(idCertificate: number) {
  return await destroyCertificate(idCertificate)
}

function* destroyCertificateEffectSaga(action: any) {
  try {
    const { certificateId } = action.payload

    yield call(handleDestroy, certificateId)

    const { data } = yield call(getList)
    yield put(fromActions.Actions.certificateAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.certificateDeleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.certificateCreateError'))
    console.log('error: ', error)
  }
}

export function* destroyCertificateWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_CERTIFICATE, destroyCertificateEffectSaga)
}